<template>
    <div class="containers">
        <div v-if="tabs == '1'">
            <div class="search-area">
                <CAlert
                v-if="success == true"
                :show.sync="currentAlertCounter"
                closeButton
                style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
                >
                {{alertMess}}
                </CAlert>
                <CAlert
                v-else
                :show.sync="currentAlertCounter"
                closeButton
                style="background-color:red;border-radius:0;text-align:center;color:white"
                >
                {{alertMess}}
                </CAlert>
                <CRow class="no-gutters">
                    <CCol style="padding-right:4px" sm="2">
                        <input type="text" v-model="searchPengadaan" placeholder="Nama Pengadaan" class="form-control"/>
                    </CCol>
                    <CCol style="padding-right:4px;padding-left:4px" sm="3">
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    @click="toggleVisibleUnit()"
                                    @blur="toggleCloseVisibleUnit()"
                                    v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                                    v-model="queryUnit"
                                    @keydown.up="upUnit"
                                    @keydown.down="downUnit"
                                    @keydown.enter="selectItemUnit"
                                    placeholder="Pilih Bidang"
                            >
                            <div class="popovers" v-show="visibleUnit">
                                <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesUnit"
                                        :key="index"
                                        :class="{ 'selected': (selectedUnit == index)}"
                                        @click="itemClickedUnit(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                    <CCol style="padding-right:6px;padding-left:4px" sm="2">
                        <month-picker-input placeholder="Bulan" :no-default="true" :show-year="true" :default-year="date.year" @change="showDate"></month-picker-input>
                    </CCol>
                    <CCol style="padding-right:4px;padding-left:4px" sm="3">
                        <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataPJTK" class="form-control" v-model="pjtk" placeholder="Pilih PJTK"></model-select>
                    </CCol>
                    <CCol style="padding-left:6px" sm="2">
                        <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                    </CCol>
                </CRow>
            </div>
            <div class="sticky1">
                <CRow class="no-gutters">
                    <CCol sm="6" style="float:left">
                        <img class="mr-4 mt-1" @click="reload()" title="refresh" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:left"/>
                        <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                        <img class="mr-4 mt-1" style="float:left" :src="moreIcon" width="20px" height="20px"/>
                    </CCol>
                    <CCol sm="6">
                        <span style="float:right">
                            <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                            <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                            <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                            <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        </span>
                        <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                        <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                        <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    </CCol>
                </CRow>
            </div>
            <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
        </div>
        <div v-if="tabs == '2'">
            <CRow class="area-back">
                <CCol sm="12">
                    <img class="mt-2 mb-2 ml-4" :src="backIcon" @click="goBack('1')" width="20px" height="20px" style="float:left;cursor:pointer"/>
                </CCol>
            </CRow>
            <div class="detail-main">
                <CRow class="mb-3">
                    <CCol sm="8">
                        <h3>Detail Pengadaan</h3>
                    </CCol>
                    <CCol sm="4" class="text-right">
                        <CButton @click="exportExcel()" type="button" class="btn btn-outline-success">Export xls</CButton>
                    </CCol>
                </CRow>
                <hr class="hr-1"/>
                <CRow class="mt-4">
                    <CCol sm="12">
                        <CRow class="mt-1">
                            <CCol sm="4">
                                Nama Pengadaan
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                                {{dataDetail.namaPengadaan}}
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="4">
                                Nomor Pengadaan
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                                {{dataDetail.nomorPengadaan}}
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="4">
                                Nama Penyedia Jasa Tenaga Kerja (PJTK)
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                                {{dataDetail.namaPerusahaan}}
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="4">
                                Bidang
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                               <CRow v-for="(lvl, id) in dataDetail.listUnitLvl" :key="id">
                                    <CCol sm="12">{{id+1}}. {{lvl.bidang}}</CCol>
                               </CRow>
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="4">
                                Qty PO/Qty Realisasi
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                                {{dataDetail.qtyPengadaan}}/{{dataDetail.qtyRealisasi}}
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="4">
                                Tanggal Pengadaan
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                                {{dataDetail.tanggalPengadaanShow}}
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol sm="4">
                                Total Nominal Pengadaan
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                                {{dataDetail.hargaPegawai}}
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <CCol sm="4">
                                <span class="font-weight-bold">Total Nominal Dibayarkan</span>
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                                <span class="font-weight-bold">{{dataDetail.hargaPegawaiPerBulan}}</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="4">
                                <span class="font-weight-bold">Fee Management ({{dataDetail.feeManagement}}%)</span>
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                                <span class="font-weight-bold">{{dataDetail.feePjtk}}</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <CCol sm="4">
                                <span class="font-weight-bold">Total Harga (Harga Dibayarkan + Fee Management)</span>
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                                <span class="font-weight-bold">{{dataDetail.hargaTotal}}</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="4">
                                Periode Laporan BAUK PO
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                                {{dataDetail.periode}}
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="4">
                                Status
                            </CCol>
                            <CCol sm="1" class="text-right">
                                :
                            </CCol>
                            <CCol sm="7">
                                {{dataDetail.statusBauk}}
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol>
                        <table>
                            <thead>
                                <tr>
                                    <th>Nama / NIP</th>
                                    <th>Jabatan</th>
                                    <th>Email</th>
                                    <th>Harga Pengadaan</th>
                                    <th>Harga Dibayarkan</th>
                                </tr>
                            </thead>
                            <tbody v-if="dataDetail.listPegawai.length != 0">
                                <tr style="cursor:pointer" @click="detailBauk(id)" v-for="(li, id) in dataDetail.listPegawai" :key="id">
                                    <td>
                                        <CRow>
                                            <CCol sm="12">
                                                {{li.nama}}
                                            </CCol>
                                            <CCol sm="12">
                                                <span style="font-size:12px;color:gray">{{li.nik}}</span>
                                            </CCol>
                                        </CRow>
                                    </td>
                                    <td>{{li.jabatan}}</td>
                                    <td>{{li.email}}</td>
                                    <td class="text-right">{{li.hargaSatuan}}</td>
                                    <td class="text-right">{{li.hargaBulanan}}</td>
                                </tr>
                            </tbody>
                            <tbody v-if="dataDetail.listPegawai.length == 0">
                                <tr>
                                    <td class="text-center p-4" colspan="5">Data tidak ditemukan, silahkan tambah pegawai.</td>
                                </tr>
                            </tbody>
                        </table>
                    </CCol>
                </CRow>
            </div>
        </div>
        <div v-if="tabs == '3'">
            <CRow class="area-back">
                <CCol sm="12">
                    <img class="mt-2 mb-2 ml-4" :src="backIcon" @click="goBack('2')" width="20px" height="20px" style="float:left;cursor:pointer"/>
                </CCol>
            </CRow>
            <div class="detail-main">
                <CRow>
                    <CCol sm="6">
                        <CRow>
                            <CCol sm="2" class="pr-0">
                                <img v-if="dataBauk.urlFoto == 'null' || dataBauk.urlFoto == ''" class="img-class" src="@/assets/image/icon_bg_man.png"/>
                                <img v-else class="img-class" @error="changeDefault" :src="dataBauk.urlFoto"/>
                            </CCol>
                            <CCol sm="10" class="py-auto mt-auto mb-auto">
                                <CRow>
                                    <CCol sm="12">
                                        <span class="color-primary f-16 weight-medium">{{dataBauk.nama}}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="12">
                                        <span class="color-secondary-2 f-14">{{dataBauk.nik}}</span>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="6" class="text-right py-auto mt-auto mb-auto">
                        <CRow>
                            <CCol sm="12">
                                <span class="color-secondary-2 f-14">
                                    JUMLAH HARGA
                                </span>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <span class="f-24 color-blue font-weight-bold">{{dataBauk.hargaTotal}}</span>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </div>
            <hr class="hr-1"/>
            <div class="detail-main">
                <CRow>
                    <CCol sm="6">
                        <CRow>
                            <CCol sm="12">
                                <span class="f-12 color-secondary">Nama Kontrak {{dataDetail.namaPerusahaan}}</span>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <span class="f-14 mb-3 color-primary">{{dataDetail.namaPerjanjianKontrak}}</span>
                                <hr class="hr-2"/>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="6">
                        <CRow>
                            <CCol sm="12">
                                <span class="f-12 color-secondary">No Kontrak {{dataDetail.namaPerusahaan}}</span>
                            </CCol>
                            <CCol sm="12">
                                <span class="f-14 mb-3 color-primary">{{dataDetail.nomorPerjanjianKontrak}}</span>
                                <hr class="hr-2"/>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <CRow class="mt-4">
                    <CCol sm="3">
                        <CRow>
                            <CCol sm="12">
                                <span class="f-12 color-secondary">Nama Pengadaan</span>
                            </CCol>
                            <CCol sm="12">
                                <span class="f-14 mb-3 color-primary">{{dataDetail.namaPengadaan}}</span>
                                <hr class="hr-2"/>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="3">
                        <CRow>
                            <CCol sm="12">
                                <span class="f-12 color-secondary">Nomor Pengadaan</span>
                            </CCol>
                            <CCol sm="12">
                                <span class="f-14 mb-3 color-primary">{{dataDetail.nomorPengadaan}}</span>
                                <hr class="hr-2"/>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="3">
                        <CRow>
                            <CCol sm="12">
                                <span class="f-12 color-secondary">Tanggal Pengadaan</span>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <span class="f-14 mb-3 color-primary">{{dataDetail.tanggalPengadaanShow}}</span>
                                <hr class="hr-2"/>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="3">
                        <CRow>
                            <CCol sm="12">
                                <span class="f-12 color-secondary">Status Pengadaan</span>
                            </CCol>
                            <CCol sm="12">
                                <span class="f-14 mb-3 color-primary">{{dataDetail.statusBauk}}</span>
                                <hr class="hr-2"/>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </div>
            <hr class="hr-1"/>
            <div class="detail-main">
                <CRow>
                    <CCol sm="4">
                        <CRow>
                            <CCol sm="12">
                                <span class="f-12 color-secondary">BIDANG</span>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <span class="f-14 mb-3 color-primary">{{dataBauk.bidang}}</span>
                                <hr class="hr-2"/>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="4">
                        <CRow>
                            <CCol sm="12">
                                <span class="f-12 color-secondary">WILAYAH</span>
                            </CCol>
                            <CCol sm="12">
                                <span class="f-14 mb-3 color-primary">{{dataBauk.wilayah}}</span>
                                <hr class="hr-2"/>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="4">
                        <CRow>
                            <CCol sm="12">
                                <span class="f-12 color-secondary">JABATAN</span>
                            </CCol>
                            <CCol sm="12">
                                <span class="f-14 mb-3 color-primary">{{dataBauk.jabatan}}</span>
                                <hr class="hr-2"/>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </div>
            <hr class="hr-1"/>
            <div class="detail-main">
                <CRow>
                    <CCol sm="12">
                        <span class="f-16 color-primary font-weight-bold">
                            Daftar Kehadiran
                        </span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="6">
                        <CRow>
                            <CCol sm="12">
                                <span class="f-12 color-secondary">JML HARI BULAN BERJALAN</span>
                            </CCol>
                            <CCol sm="12">
                                <span class="f-14 mb-3 color-primary">{{dataBauk.hks}}</span>
                                <hr class="hr-2"/>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="6">
                        <CRow>
                            <CCol sm="12">
                                <span class="f-12 color-secondary">JML HARI TERPENUHI (%)</span>
                            </CCol>
                            <CCol sm="12">
                                <span class="f-14 mb-3 color-primary">{{dataBauk.hkp}} ({{dataBauk.persentaseHkp}})</span>
                                <hr class="hr-2"/>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </div>
            <hr class="hr-1"/>
            <div class="detail-main bg-1">
                <CRow>
                    <CCol sm="12">
                        <span class="f-16 color-primary font-weight-bold">
                            Total Nominal
                        </span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="12">
                        <CRow class="mb-1">
                            <CCol sm="6" class="text-left">
                                <span class="color-primary f-14">Harga Satuan <span class="font-weight-bold">{{dataBauk.hargaSatuan}} x {{dataBauk.persentaseHkp}}</span></span>
                            </CCol>
                            <CCol sm="6" class="text-right">
                                <span class="color-primary font-weight-bold f-14">{{dataBauk.hargaBulanan}}</span>
                            </CCol>
                        </CRow>
                        <hr class="hr-3"/>
                        <CRow class="mt-1 mb-1">
                            <CCol sm="6" class="text-left">
                                <span class="color-primary f-14">Fee Adm {{dataBauk.feeManagement}}%</span>
                            </CCol>
                            <CCol sm="6" class="text-right">
                                <span class="color-primary font-weight-bold f-14">{{dataBauk.feePjtk}}</span>
                            </CCol>
                        </CRow>
                        <hr class="hr-1"/>
                        <CRow class="mt-1">
                            <CCol sm="6" class="text-left">
                                <span class="color-primary f-14">Total</span>
                            </CCol>
                            <CCol sm="6" class="text-right">
                                <span class="color-blue font-weight-bold f-18">{{dataBauk.hargaTotal}}</span>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import Tables from '../../../component/tableBaukPo'
    import {DataApi} from "../../../service/DataApi";
    import { ModelSelect } from 'vue-search-select'
    import { MonthPickerInput } from 'vue-month-picker'
    
    const xlsx = require('json-as-xlsx')
    
    export default {
        components: {
            Tables,
            MonthPickerInput,
            ModelSelect
        },
        data() {
            return {    
                tabs: '1',
                dataDetail: [],
                dataBauk: [],
                // datas
                refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
                downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
                backIcon: require('../../../assets/menu/icon_goback.svg'),
                moreIcon: require('../../../assets/menu/icon_more.svg'),
                dataTh: ['Nama Pengadaan', 'Nama PJTK', 'Bidang', 'Qty PO / Qty Real', 'Total Harga'],
                dataTd: [['namaPengadaan', 'nomorPengadaan'], 'namaPerusahaan', 'listUnitLvl', ['qtyPengadaan', 'qtyRealisasi'], 'hargaPegawaiPerBulan' ],
                styleTable: ['200px', '200px', '200px', '150px', '150px', '150px'],
                classReload: 'reloadOff',
                datas: [],
    
                // paging
                page: 1,
                size: 20,
                totalRow: 0,
                totalPage: 1,
                firstPage: 0,
                lastPage: 0,
    
                // filter
                searchPengadaan: '',

                // data search unit
                dataUnit: [],
                titleUnit:"Pilih Bidang",
                selectedItemUnit: null,
                selectedUnit: 0,
                queryUnit: '',
                visibleUnit: false,
                idUnit: '',

                // data search pjtk
                dataPJTK: [],
                pjtk: {
                    text: '',
                    value: ''
                },

                date: {
                    from: null,
                    to: null,
                    month: null,
                    monthIndex: null,
                    year: null
                },
                tanggal: new Date(),
    
                // error
                errorMessage: '',
                flagSearch: false,
    
                alertMess: '',
                currentAlertCounter: 0,
                success: true,
            }
        },
        computed: {
            matchesUnit() {
                if (this.queryUnit == '') {
                    return [];
                }
                return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
            },
        },
        watch: {
            page() {
                window.scroll({
                    top:0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            searchPengadaan() {
                this.flagSearch = true
            },
            queryUnit() {
                this.flagSearch = true
                this.queryUnit == '' ? this.idUnit = '' : ''
                this.getDataUnit()
            },
            queryPJTK() {
                this.flagSearch = true
            },
            date() {
                this.flagSearch = true
            }
        },
        methods: {    
            editData(value) {
                this.dataDetail = this.datas[value]
                this.tabs = '2'
            },
            detailBauk(val) {
                this.$store.state.loadingScreen = true
                let id = this.dataDetail.listPegawai[val].idPegawai
                let payload = {
                    bulan: this.date.monthIndex,
                    idPegawai: id,
                    tahun: this.date.year
                }
                DataApi.post("pegawai_kontrak/get/bauk_po", payload)
                .then( res => {
                    let response = res.data
                    this.dataBauk = response.data
                    this.tabs = '3'
                    this.$store.state.loadingScreen = false
                })
            },
            goBack(val) {
                if(val == '1') {
                    this.dataDetail = []
                } else {
                    this.dataBauk = []
                }
                this.tabs = val
            },
            sorting(value) {
                if(value == 0) {
                    function compare(a,b) {
                        if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                            return -1
                        }
                        if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 1) {
                    function compare(a,b) {
                        if (a.nik.toLowerCase() < b.nik.toLowerCase()) {
                            return -1
                        }
                        if (a.nik.toLowerCase() > b.nik.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 2) {
                    function compare(a,b) {
                        if (a.polaAbsensi.toLowerCase() < b.polaAbsensi.toLowerCase()) {
                            return -1
                        }
                        if (a.polaAbsensi.toLowerCase() > b.polaAbsensi.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 3) {
                    function compare(a,b) {
                        if (a.wfh.toLowerCase() < b.wfh.toLowerCase()) {
                            return -1
                        }
                        if (a.wfh.toLowerCase() > b.wfh.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 4) {
                    function compare(a,b) {
                        if (a.wfo.toLowerCase() < b.wfo.toLowerCase()) {
                            return -1
                        }
                        if (a.wfo.toLowerCase() > b.wfo.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 5) {
                    function compare(a,b) {
                        if (a.mangkir.toLowerCase() < b.mangkir.toLowerCase()) {
                            return -1
                        }
                        if (a.mangkir.toLowerCase() > b.mangkir.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 6) {
                    function compare(a,b) {
                        if (a.dinas.toLowerCase() < b.dinas.toLowerCase()) {
                            return -1
                        }
                        if (a.dinas.toLowerCase() > b.dinas.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 7) {
                    function compare(a,b) {
                        if (a.cuti.toLowerCase() < b.cuti.toLowerCase()) {
                            return -1
                        }
                        if (a.cuti.toLowerCase() > b.cuti.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 8) {
                    function compare(a,b) {
                        if (a.sakit.toLowerCase() < b.sakit.toLowerCase()) {
                            return -1
                        }
                        if (a.sakit.toLowerCase() > b.sakit.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 9) {
                    function compare(a,b) {
                        if (a.ijin.toLowerCase() < b.ijin.toLowerCase()) {
                            return -1
                        }
                        if (a.ijin.toLowerCase() > b.ijin.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 10) {
                    function compare(a,b) {
                        if (a.nsi.toLowerCase() < b.nsi.toLowerCase()) {
                            return -1
                        }
                        if (a.nsi.toLowerCase() > b.nsi.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 11) {
                    function compare(a,b) {
                        if (a.nso.toLowerCase() < b.nso.toLowerCase()) {
                            return -1
                        }
                        if (a.nso.toLowerCase() > b.nso.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 12) {
                    function compare(a,b) {
                        if (a.telat.toLowerCase() < b.telat.toLowerCase()) {
                            return -1
                        }
                        if (a.telat.toLowerCase() > b.telat.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 13) {
                    function compare(a,b) {
                        if (a.cepet.toLowerCase() < b.cepet.toLowerCase()) {
                            return -1
                        }
                        if (a.cepet.toLowerCase() > b.cepet.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 14) {
                    function compare(a,b) {
                        if (a.lembur.toLowerCase() < b.lembur.toLowerCase()) {
                            return -1
                        }
                        if (a.lembur.toLowerCase() > b.lembur.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 15) {
                    function compare(a,b) {
                        if (a.hariKerjaKalender.toLowerCase() < b.hariKerjaKalender.toLowerCase()) {
                            return -1
                        }
                        if (a.hariKerjaKalender.toLowerCase() > b.hariKerjaKalender.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                } else if(value == 16) {
                    function compare(a,b) {
                        if (a.hariKerjaPegawai.toLowerCase() < b.hariKerjaPegawai.toLowerCase()) {
                            return -1
                        }
                        if (a.hariKerjaPegawai.toLowerCase() > b.hariKerjaPegawai.toLowerCase()) {
                            return 1
                        }
                        return 0
                    }
                    return this.datas.sort(compare)
                }
            },
            getDownload() {
                this.$store.state.loadingScreen = true
                let payload = {
                    bulan: this.date.monthIndex,
                    namaPengadaan: this.searchPengadaan,
                    pjtk: this.pjtk.value,
                    tahun: this.date.year,
                    unitLevel: this.idUnit,
                    limit: "",
                    pageIn: 1
                }
                DataApi.post("kontrak_pengadaan/get/bauk_po", payload)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        let downloads = response.data.data
                        let fileName = 'Pengadaan BAUK PO ' + downloads.periode
                        let data = [
                            {
                                sheet: fileName,
                                columns: [
                                    { label: 'Nama Pengadaan', value: 'namaPengadaan'  },
                                    { label: 'Nomor Pengadaan', value: 'nomorPengadaan' },
                                    { label: 'Nama PJTK', value: 'namaPerusahaan' },
                                    { label: 'Qty Pengadaan', value: 'qtyPengadaan' },
                                    { label: 'Qty Realisasi', value: 'qtyRealisasi' },
                                    { label: 'Tanggal Pengadaan', value: 'tanggalPengadaan' },
                                    { label: 'Periode BAUK PO', value: 'periode'},
                                    { label: 'Harga Pegawai', value: 'hargaPegawaiPerBulan'},
                                    { label: 'Fee Management', value: 'totalManagementFee'},
                                    { label: 'Total', value: 'hargaTotal'},
                                    { label: 'Status', value: 'statusBauk'}
                                ],
                                content: downloads
                            }
                        ]
                        let settings = {
                            fileName: fileName
                        }
                        xlsx(data, settings)
                    }
                    this.$store.state.loadingScreen = false
                })
            },
            getData() {
                this.$store.state.loadingScreen = true
                this.flagSearch ? this.page = 1 : ''
                let payload = {
                    bulan: this.date.monthIndex,
                    namaPengadaan: this.searchPengadaan,
                    pjtk: this.pjtk.value,
                    tahun: this.date.year,
                    unitLevel: this.idUnit,
                    limit: this.size,
                    pageIn: this.page
                }
                DataApi.post("kontrak_pengadaan/get/bauk_po", payload)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.datas = response.data.data
                        this.totalRow = response.data.totalRow
                        this.firstPage = (((this.page - 1) * this.size) + 1 )
                        this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                        this.totalPage = Math.floor(this.totalRow/this.size)
                        let modAr = this.totalRow%this.size
                        if(modAr != 0) {
                            this.totalPage = this.totalPage + 1
                        } else {
                            //
                        }
                    } else {
                        this.datas = []
                        this.errorMessage = response.message
                        this.firstPage = 0
                        this.lastPage = 0
                        this.totalRow = 0
                        this.totalPage = 1
                    }
                    this.flagSearch = false
                    this.$store.state.loadingScreen = false
                })
            },
            findData() {
                this.getData()
            },
            reload() {
                this.queryPegawai = ''
                this.queryUnit = ''
                this.idUnits = ''
                this.getDataPegawai()
                this.getDataUnit()
                this.flagSearch = true
                this.getData()
                if (this.classReload == 'reloadOff') {
                    this.classReload = 'reloadOn'
                } else {
                    this.classReload = 'reloadOff'
                }
            },
            movePage(direction) {
                if(direction == 'prev') {
                    this.page = this.page -  1
                } else {
                    this.page = this.page +  1
                }
                this.getData()
            },
            validatePage(page) {
                if(page > this.totalPage) {
                    this.page = this.totalPage
                }
            },

            /**
             * SEARCH PJTK
             */
            getDataPJTK() {
                let payload = {
                    limit: 9999,
                    namaOrganisasi: '',
                    organisasi: '',
                    pageIn: 1,
                    pjtk: 'Y'
                }
                DataApi.post("perusahaan/get", payload)
                .then(res => {
                    this.dataPJTK = [
                        {
                            text: 'Semua PJTK',
                            value: ''
                        }
                    ]
                    let response = res.data
                    let tempData = response.data.data
                    var i = 0;
                    for(i=0;i<tempData.length;i++) {
                        let onPush = {
                            value: tempData[i].kode,
                            text: tempData[i].nama
                        }
                        this.dataPJTK.push(onPush)
                    }
                })
            },

            /**
             * SEARCH UNIT LEVEL
             */
            getDataUnit() {
                let payload = {
                    limit: 10,
                    namaUnit: this.queryUnit,
                    pageIn: 1,
                    namaParentUnit: '',
                    idUnit: ''
                }
                DataApi.post("unit/get", payload)
                .then(res => {
                    this.dataUnit = []
                    let response = res.data.data
                    let tempData = response.data
                    var i = 0;
                    for(i=0;i<tempData.length;i++) {
                        let onPush = ''
                        if(tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                            onPush = {
                                value: tempData[i].id,
                                text: tempData[i].bidang
                            }                      
                        } else {
                            onPush = {
                                value: tempData[i].id,
                                text: tempData[i].bidang + ' - ' + tempData[i].parentBidang                            
                            }
                        }
                        this.dataUnit.push(onPush)
                    }
                })
            },
            toggleVisibleUnit() {
                this.visibleUnit = true;
            },
            hideUnit() {
                this.visibleUnit = false;
            },
            toggleCloseVisibleUnit() {
                setTimeout(this.hideUnit, 1000);
            },
            itemClickedUnit(index) {
                this.selectedUnit = index;
                this.selectItemUnit();
            },
            selectItemUnit() {
                if (!this.matchesUnit.length) {
                return;
                }
                this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
                this.queryUnit = this.selectedItemUnit.text
                this.idUnit = this.selectedItemUnit.value
                this.visibleUnit = false;
                if (this.shouldReset) {
                this.queryUnit = '';
                this.selectedUnit = 0;
                }
            },
            upUnit() {
                if (this.selectedUnit == 0) {
                return;
                }
                this.selectedUnit -= 1;
                this.scrollToItemUnit();
            },
            downUnit() {
                if (this.selectedUnit >= this.matchesUnit.length - 1) {
                return;
                }
                this.selectedUnit += 1;
                this.scrollToItemUnit();
            },
            scrollToItemUnit() {
                this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
            },
            setDate() {
                let month = this.tanggal.getMonth() + 1
                let year = this.tanggal.getFullYear()
                this.date.monthIndex = month
                this.date.year = year
            },
            showDate(date) {
                this.date = date
            },
            exportExcel() {
                let payload = {
                    bulan: this.date.monthIndex,
                    idKontrakPengadaan: this.dataDetail.idKontrakPengadaan,
                    tahun: this.date.year
                }
                DataApi.post("/export/kontrak_pengadaan/bauk_po", payload , {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Data BAUK PO ' + this.dataDetail.namaPengadaan + ' ' + this.dataDetail.periode)
                    document.body.appendChild(link)
                    link.click()
                })
            },
            changeDefault(e) {
                e.target.src = require('@/assets/image/icon_bg_man.png')
            }
        },
        mounted() {
            this.errorMessage = 'Find Your Data'
            this.getDataPJTK()
            this.getDataUnit()
            this.setDate()
        }
    }
    </script>
    <style scoped>
    .autocomplete {
        width: 100%;
        position: relative;
    }
    .input {
        cursor: text;
    }
    .close {
        position: absolute;
        right: 8px;
        top: 10px;
        background: none;
        border: none;
        font-size: 14px;
        color: lightgrey;
        cursor: pointer;
    }
    .placeholder {
        position: absolute;
        top: 7px;
        left: 16px;
        font-size: 14px;
        color: #d0d0d0;
    }
    .popovers {
        text-align: center;
        width: 100% !important;
        min-height: 50px;
        border: 1px solid #d8dbe0;
        position: absolute;
        top: 35px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 8px;
        left: 0;
        right: 0;
        background: #fff;
        border-radius: 3px;
        text-align: center;
        z-index: 3;
    }
    .popovers input {
        right: 8px;
        left: 8px;
        width: 100%;
    }
    .options {
        max-height: 200px;
        overflow-y: auto;
        margin-top: 5px;
    }
    .options ul {
        list-style-type: none;
        text-align: left;
        padding-left: 0;
    }
    .options ul li {
        border-bottom: 1px solid lightgrey;
        padding: 10px;
        cursor: pointer;
        background: white;
    }
    .options ul li:first-child {
        border-top: 1px solid lightgray;
    }
    .options ul li:not(.selected):hover {
        background: whitesmoke;
        color: rgba(16, 16, 16, 1);
    }
    .options ul li.selected {
        background: whitesmoke;
        color: rgba(16, 16, 16, 1);
    }
    .nowraps {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .card-title {
        font-size: 14px;
        font-weight: 600;
        color: rgba(16, 16, 16, 1);
    }
    .card-subtitle {
        font-size: 12px;
        color: rgba(154, 154, 154, 1);
    }
    .card-emblem {
        float:right;
        background-color:rgba(48, 107, 221, 0.05);
        text-align: center;
        line-height: 32px;
        min-width:40px;
        min-height:40px;
        border-radius:50%;
    }
    input[type="checkbox"] {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
    .containers {
        background-color: white;
        border-bottom: 1px solid #e5e6e8;
    }
    .btn-search {
        border-radius: 4px;
        float: right;
        width: 100%;
        background-color:rgba(48, 107, 221, 1);
        color: white;
    }
    .btn-search:hover {
        border-radius: 4px;
        float: right;
        width: 100%;
        background-color:rgba(48, 107, 255, 1);
        color: white;
    }
    .reloadOn {
        float: left;
        cursor: pointer;
        transform: rotate(360deg);
        transition: 300ms linear all;
    }
    .reloadOff {
        float: left;
        cursor: pointer;
        transform: rotate(0deg);
        transition: 300ms linear all;
    }
    div.search-area {
        padding-top: 12px;
        padding-left: 24px;
        padding-right: 24px;
        padding-bottom: 12px !important;
        background-color: white;
        z-index: 1;
    }
    div.sticky1 {
        position: -webkit-sticky;
        position: sticky;
        top: 54px;
        padding-top: 12px;
        padding-right: 24px;
        padding-left: 24px;
        padding-bottom: 12px !important;
        background-color: white;
        z-index: 1;
    }
    input {
        background-color: rgba(249, 250, 252, 1);
    }
    .btn-add {
        border-radius: 4px;
        width: 100%;
        margin-right: 6px;
        border: 1px solid rgba(48, 107, 221, 1);
        background-color:white;
        color: rgba(16, 16, 16, 1);
        font-weight: 500;
        font-size: 14px;
    }
    .btn-add:hover {
        border-radius: 4px;
        width: 100%;
        margin-right: 6px;
        border: 1px solid rgba(48, 107, 221, 1);
        background-color: rgba(48, 107, 221, 1);
        color: white;
    }
    ::v-deep .month-picker__container {
        z-index: 5 !important;
        width: 250px !important;
    }
    ::v-deep .month-picker__year button {
        width: 50px;
        height: 48px;
    }
    ::v-deep .month-picker-input {
        display: block;
        width: 100% !important;
        height: 36px !important;
        padding: .375rem .75rem;
        font-size: .875rem;
        font-weight: 400;
        line-height: 1.5;
        background-clip: padding-box;
        border: 1px solid;
        color: #768192;
        border-color: #d8dbe0;
        background-color: #f9fafc;
        border-radius: .25rem;
    }
    ::v-deep .month-picker-input-container {
        width: 100% !important;
        height: 35px !important;
        min-width: none;
    }
    .area-back {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.detail-main {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
}
.bg-1 {
    background-color: rgba(244, 244, 244, 1);
}

.color-primary {
    color: #101010;
}
.color-secondary {
    color: #606060;
}
.color-secondary-2 {
    color: #9a9a9a;
}
.color-blue {
    color: #306bdd;
}
.weight-medium {
    font-weight: 600;
}

table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 8px;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 8px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 8px;
    padding-right: 8px;
}
td,th {
    /* overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap; */
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}

.f-12 {
    font-size: 12px;
}
.f-14 {
    font-size: 14px;
}
.f-16 {
    font-size: 16px;
}
.f-18 {
    font-size: 18px;
}
.f-24 {
    font-size: 24px;
}
.bb-1 {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
}
.hr-1 {
    border:1px solid rgba(224, 224, 224, 1);
    margin-top: 0px !important;
    margin-bottom: 0px !important;
}
.hr-2 {
    border:1px solid rgba(224, 224, 224, 1);
    margin-bottom: 0px !important;
    margin-top: 8px !important;
}
.hr-3 {
    border:1px dashed rgba(224, 224, 224, 1);
    margin-bottom: 0px !important;
    margin-top: 0px !important;
}
.img-class {
    object-fit: cover;
    padding-right: 0;
    width: 100%;
    border-radius: 50%;
}

    </style>